import { gql } from 'graphql.macro';

export const orgAddressFragment = gql`
    fragment orgAddressFields on Address {
        street
        street2
        city
        postalCode
        geoLocation {
            latitude
            longitude
        }
        country
        deliveryInstructions
    }
`;

export const orgContactFragment = gql`
    fragment orgContactFields on OrganizationContact {
        address {
            ...orgAddressFields
        }
        postalAddress {
            ...orgAddressFields
        }
        communication {
            phone
            site
            email
        }
    }
    ${orgAddressFragment}
`;

export const customerSettingsFragment = gql`
    fragment customerSettingsFields on CustomerSettings {
        _id
        name
        value
        type
    }
`;
